import { Snackbar, Alert, SnackbarOrigin, Typography } from '@mui/material';
import { snackBarSX } from '@/components/content/Notifications/styles/snackbar';
import { alertSX } from '@/components/content/Notifications/styles/alert';
import { NotificationText } from '@/data/context/notifications';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SnackbarAlertProps {
	id: string;
	title?: NotificationText;
	message?: NotificationText;
	anchorOrigin?: SnackbarOrigin;
	severity?: 'error' | 'success' | 'info' | 'warning';
	duration?: number;
	onClear: () => void;
}

export const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
	id,
	title,
	message,
	anchorOrigin,
	severity = 'info',
	duration = 5000,
	onClear,
}) => {
	const isSuccess = severity === 'success';

	return (
		<Snackbar
			id={id}
			open={message ? true : false}
			anchorOrigin={anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
			autoHideDuration={duration}
			onClose={onClear}
			ClickAwayListenerProps={{
				onClickAway: onClear,
				mouseEvent: 'onMouseDown',
			}}
			sx={snackBarSX}
		>
			<Alert severity={severity} onClose={onClear} sx={alertSX(severity)} icon={false}>
				{title ? (
					<Typography
						sx={{
							fontWeight: 800,
							fontSize: '18px',
							color: 'inherit',
							mb: '6px',
						}}
					>
						{title}
					</Typography>
				) : null}
				<Typography sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					{isSuccess ? <CheckCircleIcon fontSize="inherit" htmlColor="inherit" /> : null}
					{message}
				</Typography>
			</Alert>
		</Snackbar>
	);
};
